import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import {DvVersicherungsbeitragBeitragComponentConfig} from './component/versicherungsbeitragBeitragView/component/dv-versicherungsbeitragBeitrag';
import {BeitragViewComponentConfig} from './component/versicherungsbeitragBeitragView/versicherungsbeitragBeitragView';
import {VersicherungsbeitraegeListViewComponentConfig} from './component/versicherungsbeitragListView/versicherungsbeitraegeListView';
import {VersicherungsbeitragSchadenViewComponentConfig} from './component/versicherungsbeitragSchadenView/versicherungsbeitragSchadenView';
import {VersicherungsbeitragVersicherterViewComponentConfig} from './component/versicherungsbeitragVersicherterView/versicherungsbeitragVersicherterView';
import './versicherungsbeitraege.module.scss';
import {versicherungsbeitraegeRun} from './versicherungsbeitraege.route';

export const SerfWebversicherungsbeitraege = angular.module('serfWeb.versicherungsbeitraege', [SerfWebCore.name])
    .component('versicherungsbeitraegeListView', new VersicherungsbeitraegeListViewComponentConfig())
    .component('versicherungsbeitragSchadenView', new VersicherungsbeitragSchadenViewComponentConfig())
    .component('versicherungsbeitragBeitragView', new BeitragViewComponentConfig())
    .component('versicherungsbeitragVersicherterView', new VersicherungsbeitragVersicherterViewComponentConfig())
    .component('dvVersicherungsbeitragBeitrag', new DvVersicherungsbeitragBeitragComponentConfig())
    .run(versicherungsbeitraegeRun);

export default SerfWebversicherungsbeitraege;



// WEBPACK FOOTER //
// ./src/app/versicherungsbeitraege/versicherungsbeitraege.module.ts